import React from 'react';
import { makeStyles } from '@mui/styles';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
//import ListSubheader from '@mui/material/ListSubheader';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Select from '@mui/material/Select';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import RcSwitch from 'rc-switch';
//import TextField from '@mui/material/TextField';
import { default as ReactSelect } from 'react-select';
import logger from '../utils/logger';
var log = logger.createLogger('Encoder');
import styles from '../styles/file-uploader.less';
import { STATUS_COMPRESSING, STATUS_UPLOADING, STATUS_DONE, STATUS_ERROR, STATUS_COMPRESSED } from './compressFile';

//point size, color, title
//edge color, title
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Encoder(props) {
  var visible = props.visible,
    user = props.user,
    files = props.files,
    visualizationBindings = props.visualizationBindings,
    setVisualizationBindings = props.setVisualizationBindings;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(Card, {
      className: "".concat(styles['viz-form-card'], " ").concat(styles["encoder"]),
      children: [/*#__PURE__*/_jsx(Card.Header, {
        className: styles['encoder-header'],
        children: "Encode nodes"
      }), /*#__PURE__*/_jsx(Card.Body, {
        className: styles['encoder-body'],
        children: /*#__PURE__*/_jsx(Card.Title, {
          children: "Configure node visuals using node data"
        })
      })]
    }), /*#__PURE__*/_jsx("hr", {}), /*#__PURE__*/_jsxs(Card, {
      className: "".concat(styles['viz-form-card'], " ").concat(styles["encoder"]),
      children: [/*#__PURE__*/_jsx(Card.Header, {
        className: styles['encoder-header'],
        children: "Encode edges"
      }), /*#__PURE__*/_jsx(Card.Body, {
        className: styles['encoder-body'],
        children: /*#__PURE__*/_jsx(Card.Title, {
          children: "Configure edge visuals using edge data"
        })
      })]
    })]
  });
}